module.exports = __webpack_public_path__ + "static/media/gnestavapen.03c3ba9f.png";